import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0481. ワークスペース招待取消
 * [DELETE] /workspaces/:identifier/user_invitations/:id
 */
type Props = {
  identifier: string;
  id: number;
};
export const destroyUserInvitation = (props: Props): Promise<any> => {
  return axios.delete(`/api/workspaces/${props.identifier}/user_invitations/${props.id}`);
};

export const useDestroyUserInvitation = () => {
  return useMutation({
    mutationFn: destroyUserInvitation,
  });
};
